import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

function LegalLayout({ titleKey, updatedKey, introKey, sections }) {
  const { t } = useI18n();
  return (
    <main
      data-testid="legal-page"
      className="bg-white py-16 lg:py-24 border-t border-slate-100"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-widest text-[#059669]">
          {t(updatedKey)}
        </p>
        <h1 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight">
          {t(titleKey)}
        </h1>
        <p className="mt-6 text-slate-700 leading-relaxed">{t(introKey)}</p>
        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.title} data-testid={`section-${s.title}`}>
              <h2 className="text-xl sm:text-2xl font-semibold text-slate-900">
                {t(s.title)}
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                {t(s.body)}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

export function PrivacyPage() {
  return (
    <LegalLayout
      titleKey="privacy.title"
      updatedKey="privacy.updated"
      introKey="privacy.intro"
      sections={[
        { title: "privacy.s1_title", body: "privacy.s1_body" },
        { title: "privacy.s2_title", body: "privacy.s2_body" },
        { title: "privacy.s3_title", body: "privacy.s3_body" },
        { title: "privacy.s4_title", body: "privacy.s4_body" },
        { title: "privacy.s5_title", body: "privacy.s5_body" },
        { title: "privacy.s6_title", body: "privacy.s6_body" },
        { title: "privacy.s7_title", body: "privacy.s7_body" },
      ]}
    />
  );
}

export function CookiesPage() {
  return (
    <LegalLayout
      titleKey="cookies_page.title"
      updatedKey="cookies_page.updated"
      introKey="cookies_page.intro"
      sections={[
        { title: "cookies_page.s1_title", body: "cookies_page.s1_body" },
        { title: "cookies_page.s2_title", body: "cookies_page.s2_body" },
        { title: "cookies_page.s3_title", body: "cookies_page.s3_body" },
        { title: "cookies_page.s4_title", body: "cookies_page.s4_body" },
        { title: "cookies_page.s5_title", body: "cookies_page.s5_body" },
      ]}
    />
  );
}

export function TermsPage() {
  return (
    <LegalLayout
      titleKey="terms.title"
      updatedKey="terms.updated"
      introKey="terms.intro"
      sections={[
        { title: "terms.s1_title", body: "terms.s1_body" },
        { title: "terms.s2_title", body: "terms.s2_body" },
        { title: "terms.s3_title", body: "terms.s3_body" },
        { title: "terms.s4_title", body: "terms.s4_body" },
        { title: "terms.s5_title", body: "terms.s5_body" },
        { title: "terms.s6_title", body: "terms.s6_body" },
      ]}
    />
  );
}
